import React from "react";
import {
  Typography,
  Button,
  CardContent,
  Card,
  LinearProgress,
  CardActions,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import StatBox from "../../../shared-components/StatBox";
import {
  calculateProgressPercent,
  formatProgressFraction,
} from "../../../utils/formatters";

function QuestionStatBox(props) {
  return <StatBox cardVariant={"outlined"} {...props} />;
}

export const AssignmentQuestionCard = ({
  assignmentQuestion,
  onClick,
  StatusComponent,
  mark,
  availableMarks,
  studentView = false,
  disableSubmit = false,
  sx = {},
}) => {
  return (
    <Card sx={{ ...sx }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          {/* Left side: Question info */}
          <Grid size={9}>
            <Typography variant="h5" color="text.primary">
              Question {assignmentQuestion.identifier}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.primary"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {assignmentQuestion.question.questionText}
            </Typography>
          </Grid>
          {studentView && (
            <Grid size={3}>
              <Grid
                container
                direction="column"
                alignItems="flex-end"
                spacing={0.5}
              >
                <Grid item>{StatusComponent}</Grid>

                {mark && availableMarks && (
                  <Grid item>
                    <Typography variant="h6">
                      {mark} / {availableMarks}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>

        {!studentView && (
          <Grid container spacing={2} direction={"row"} sx={{ mt: 2, mb: 2 }}>
            <Grid size={6}>
              <QuestionStatBox
                title="Submissions"
                stat={formatProgressFraction(
                  assignmentQuestion.stats.overallSubmissions,
                )}
                footer={
                  <LinearProgress
                    variant="determinate"
                    value={calculateProgressPercent(
                      assignmentQuestion.stats.overallSubmissions,
                    )}
                  />
                }
              />
            </Grid>
            <Grid size={6}>
              <QuestionStatBox
                title="Average Score"
                stat={
                  assignmentQuestion.stats.averageScore.current
                    ? `${assignmentQuestion.stats.averageScore.current} %`
                    : "N/A"
                }
                // We don't want to show footer here as its multiple questions so we can't compare to previous assignment
              />
            </Grid>
          </Grid>
        )}
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button variant="card-action" color="primary" onClick={onClick}>
          {studentView
            ? disableSubmit
              ? "Review"
              : "Review / Upload Answer"
            : "Review / Upload Answers"}
        </Button>
      </CardActions>
    </Card>
  );
};
